/**
 * Networks shown first (in this order) in the network dropdown.
 * Others follow alphabetically.
 */
export const NETWORK_PRIORITIES = ['TRC20', 'ERC20', 'BEP20'];

/**
 * Crypto providers shown first (in this order) in your crypto list.
 * Others follow alphabetically.
 */
export const CRYPTO_PROVIDER_PRIORITIES = ['Mithra', 'MoonPay'];

/**
 * Crypto currencies shown first (in this order) in your crypto list.
 * Others follow alphabetically.
 */
export const CRYPTO_CURRENCY_PRIORITIES = ['USDT', 'ETH', 'BTC', 'VATAN', 'TRX', 'BNB', 'SHIB'];

/**
 * Fallback currencies for “other” cryptos, before using CRYPTO_CURRENCY_PRIORITIES.
 */
export const OTHER_CRYPTO_CURRENCY_PRIORITIES = ['VATAN', 'TRUMP'];

/**
 * Credit-card providers shown first (in this order) in your credit-card list.
 * Others follow alphabetically.
 */
export const CREDIT_CARD_PROVIDER_PRIORITIES = ['CentralPay'];

/**
 * Credit-card currencies shown first (in this order) in your credit-card list.
 * Others follow alphabetically.
 */
export const CREDIT_CARD_CURRENCY_PRIORITIES = ['IRT'];
